(function(){
  var SECTION = 'lits-cart-drawer';
  var overlay, panel;
  function q(s, r){ return (r || document).querySelector(s); }
  function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
  function ensureRefs(){ overlay = q('[data-cd-overlay]'); panel = q('[data-cd-panel]'); return overlay && panel; }
  function openDrawer(){ if (!ensureRefs()) return; overlay.classList.add('open'); panel.classList.add('open'); panel.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(){ if (!ensureRefs()) return; overlay.classList.remove('open'); panel.classList.remove('open'); panel.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; }
  function setBusy(on){ var s = q('.lits-cd-scroll'); if (s) s.classList.toggle('is-busy', !!on); var p = q('[data-cd-panel]'); if (p) p.classList.toggle('is-loading', !!on); }
  function markSyncing(on){ var b = q('[data-cd-body]'); if (b) b.classList.toggle('syncing', !!on); }
  function fmtMoney(n){ return '$' + Number(n).toFixed(2); }
  function adjustTitleCount(delta){ if (!delta) return; var nEl = q('.cd-title .cd-n'); var m = nEl && nEl.textContent.match(/(\d+)/); if (m) { var nc = Number(m[1]) + delta; if (nc < 0) nc = 0; nEl.textContent = '(' + nc + ')'; } }

  var qtyTimers = {}, qtyTargets = {};
  function flushQty(line){
    var qty = qtyTargets[line]; if (qty === undefined) return;
    delete qtyTargets[line]; clearTimeout(qtyTimers[line]);
    cartPost('/cart/change.js', { line: line, quantity: qty })
      .then(function(cart){ apply(cart); markSyncing(false); return maybeAutoGwp(cart); })
      .catch(function(){ markSyncing(false); });
  }
  function scheduleQty(line){ clearTimeout(qtyTimers[line]); qtyTimers[line] = setTimeout(function(){ flushQty(line); }, 350); }

  function syncCounts(){
    var t = q('.cd-title');
    if (!t) return;
    var m = t.textContent.match(/\((\d+)\)/);
    qa('.cart-count').forEach(function(el){ el.textContent = m ? m[1] : '0'; });
  }
  function copyData(from, to){
    ['gwp-enabled','unit-goal','units','unit-map','milestones','gwp-default','gwp-handles'].forEach(function(k){
      to.setAttribute('data-' + k, from.getAttribute('data-' + k) || '');
    });
  }

  // Unit counter (v16 offer stack). Every reward milestone is measured in sauce UNITS, never dollars.
  // Liquid renders a handle:units map from each product's custom.unit_count metafield (single = 1,
  // 3-pack = 3, Full Collection = 6, Flavour Flight = 1, free mini = 0, gift card = 0) into
  // data-unit-map on every re-render, and this sums units x quantity over the live /cart.js items.
  function unitMap(){
    var body = q('[data-cd-body]'); var map = {};
    if (!body) return map;
    (body.getAttribute('data-unit-map') || '').split(',').forEach(function(pair){
      var i = pair.lastIndexOf(':'); if (i < 1) return;
      var n = Number(pair.slice(i + 1)); if (!isNaN(n)) map[pair.slice(0, i)] = n;
    });
    (body.getAttribute('data-gwp-handles') || '').split(',').forEach(function(h){ if (h) map[h] = 0; });
    return map;
  }
  function countUnits(cart){
    var map = unitMap(), total = 0;
    (cart && cart.items ? cart.items : []).forEach(function(it){
      var u = (it.handle in map) ? map[it.handle] : ((it.gift_card || it.product_type === 'Gift Card') ? 0 : 1);
      total += u * (Number(it.quantity) || 0);
    });
    return total;
  }
  window.litsCartUnits = countUnits;

  function optimisticQty(row, span, cur, target){
    if (span) {
      if (target <= 0) { row.style.opacity = '0.35'; row.style.pointerEvents = 'none'; }
      else { span.textContent = target; }
    }
    if (row && target > 0) {
      var unitEl = q('.cd-unit', row), lp = q('.cd-lp', row);
      if (unitEl && lp) { var unit = parseFloat(unitEl.textContent.replace(/[^0-9.]/g, '')); if (!isNaN(unit)) lp.textContent = fmtMoney(unit * target); }
    }
    adjustTitleCount(target - cur);
  }

  // Optimistic first-add: on a MAIN-page (PDP) add, drop a provisional line into the drawer
  // instantly from page data so the first add feels immediate; apply() reconciles to server
  // truth ~0.7s later. Best-effort + defensive: returns false (fall back to spinner) if it
  // can't build a line, and is SKIPPED for in-drawer adds (cross-sell / GWP) to avoid guessing.
  function optimisticAdd(form){
    try {
      var body = q('[data-cd-body]'); if (!body) return false;
      var qi = form.querySelector('[name="quantity"]');
      var qty = qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
      var ds = form.dataset || {};
      var card = form.closest('.product-card');
      var scope = form.closest('.pdp') || (card ? null : document.querySelector('.pdp')) || card || document;
      var te = ds.cdTitle ? null : scope.querySelector(card ? 'h3' : 'h1');
      var title = ds.cdTitle || (te ? te.textContent.trim().split(' - ')[0] : '');
      var pe = ds.cdPrice ? null : (scope.querySelector('.price-block .price') || scope.querySelector('.price') || scope.querySelector('.product-price'));
      var price = ds.cdPrice ? parseFloat(ds.cdPrice.replace(/[^0-9.]/g, '')) : (pe ? parseFloat(pe.textContent.replace(/[^0-9.]/g, '')) : NaN);
      var ie = ds.cdImage ? null : scope.querySelector(card ? '.product-img img' : '.pdp-media img, [class*="gallery"] img, .product__media img, .product-single__photo img, .featured-image img');
      var img = ds.cdImage || (ie ? (ie.currentSrc || ie.getAttribute('src') || '') : '');
      var lineHtml = '<div class="cd-line cd-line--pending">' +
        (img ? '<img src="' + img + '" alt="" width="66" height="66">' : '<div class="cd-ph">🌶️</div>') +
        '<div><div class="cd-t">' + (title || ((window.LITS_I18N && window.LITS_I18N.adding) || 'Adding your sauce…')) + '</div>' +
        (isNaN(price) ? '' : '<div class="cd-unit">' + ((window.LITS_I18N && window.LITS_I18N.each) || '%price each').replace('%price', '$' + price.toFixed(2)) + '</div>') + '</div>' +
        '<div class="cd-right"><div class="cd-lp">' + (isNaN(price) ? '' : '$' + (price * qty).toFixed(2)) + '</div>' +
        '<div class="cd-qty"><span>' + qty + '</span></div></div>' +
        '</div>';
      var lines = q('.cd-lines');
      if (lines) { lines.insertAdjacentHTML('afterbegin', lineHtml); return true; }
      body.innerHTML = '<div class="lits-cd-scroll"><p class="cd-validate"><span class="flame">🌶️</span>Nice taste. This one\'s a keeper.</p><div class="cd-lines">' + lineHtml + '</div></div>';
      return true;
    } catch (e) { return false; }
  }

  function apply(res){
    var html = res && res.sections && res.sections[SECTION];
    if (!html) return res;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fb = q('[data-cd-body]', tmp), lb = q('[data-cd-body]');
    if (fb && lb) { lb.innerHTML = fb.innerHTML; copyData(fb, lb); }
    var fh = q('.cd-title', tmp), lh = q('.cd-title');
    if (fh && lh) lh.innerHTML = fh.innerHTML;
    syncCounts();
    return res;
  }

  function getCart(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); }
  function cartPost(url, body){
    body = body || {}; body.sections = SECTION; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-LITS-Drawer': '1' }, body: JSON.stringify(body) }).then(function(r){ return r.json(); });
  }
  function addForm(fd){
    fd.append('sections', SECTION); fd.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-LITS-Drawer': '1' }, body: fd }).then(function(r){ return r.json(); });
  }

  var gwpBusy = false;
  // Free 60mL mini: auto-add at the Full Stack (unit count >= goal, default 6), auto-remove below it.
  // The mini's own line is 0 units so it can never feed its own threshold.
  function maybeAutoGwp(cart){
    var body = q('[data-cd-body]');
    if (!body || body.getAttribute('data-gwp-enabled') !== '1' || gwpBusy) return;
    var goal = Number(body.getAttribute('data-unit-goal')) || 6;
    var handles = (body.getAttribute('data-gwp-handles') || '').split(',');
    var defaultId = body.getAttribute('data-gwp-default') || '';
    function isGwp(it){ return handles.indexOf(it.handle) !== -1; }
    function proceed(c){
      var gwpItems = c.items.filter(isGwp);
      var qualifies = countUnits(c) >= goal && c.item_count > 0;
      if (!qualifies) {
        if (gwpItems.length) { gwpBusy = true; var u = {}; gwpItems.forEach(function(it){ u[it.key] = 0; }); return cartPost('/cart/update.js', { updates: u }).then(function(nc){ gwpBusy = false; apply(nc); }); }
        return;
      }
      if (gwpItems.length === 0) { if (!defaultId) return; gwpBusy = true; return cartPost('/cart/add.js', { id: Number(defaultId), quantity: 1 }).then(function(){ return cartPost('/cart/update.js', {}); }).then(function(nc){ gwpBusy = false; apply(nc); }); }
      if (gwpItems.length > 1) { gwpBusy = true; var keep = gwpItems[0].key, u2 = {}; gwpItems.forEach(function(it){ if (it.key !== keep) u2[it.key] = 0; }); return cartPost('/cart/update.js', { updates: u2 }).then(function(nc){ gwpBusy = false; apply(nc); }); }
    }
    if (cart && cart.items) return proceed(cart);
    var rendered = Number(body.getAttribute('data-units'));
    var hasGwpRow = !!q('[data-gwp-added]', body) || !!q('.cd-line .cd-free-tag', body);
    if (!isNaN(rendered) && rendered < goal && !hasGwpRow) return;
    return getCart().then(proceed);
  }

  function refresh(){ return cartPost('/cart/update.js', {}).then(function(cart){ apply(cart); setBusy(false); return maybeAutoGwp(cart); }).catch(function(){ setBusy(false); }); }

  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (a) {
      var href = a.getAttribute('href') || '';
      var isCartLink = a.classList.contains('cart') || a.classList.contains('mobile-cta') || a.getAttribute('data-action') === 'open-drawer' || /\/cart\/?($|\?)/.test(href);
      if (isCartLink && !a.hasAttribute('data-cd-keep-link')) { e.preventDefault(); e.stopPropagation(); openDrawer(); setBusy(true); refresh(); return; }
    }
    if (e.target.closest && e.target.closest('[data-cd-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.hasAttribute && e.target.hasAttribute('data-cd-overlay')) { closeDrawer(); return; }
    var ch = e.target.closest ? e.target.closest('[data-cd-change]') : null;
    if (ch) {
      e.preventDefault();
      var line = Number(ch.getAttribute('data-line'));
      var step = ch.getAttribute('data-step');
      var row = ch.closest('.cd-line');
      var span = row ? q('.cd-qty span', row) : null;
      var cur = (qtyTargets[line] !== undefined) ? qtyTargets[line] : (span ? Number(span.textContent) : 1);
      var target = (step === 'remove') ? 0 : Math.max(0, cur + Number(step));
      if (target === cur && step !== 'remove') return;
      optimisticQty(row, span, cur, target);
      qtyTargets[line] = target;
      markSyncing(true);
      scheduleQty(line);
      return;
    }
    var sw = e.target.closest ? e.target.closest('.cd-gwp-swap') : null;
    if (sw) {
      e.preventDefault();
      var newId = sw.getAttribute('data-variant');
      if (!newId) return;
      sw.disabled = true; sw.textContent = 'Swapping…';
      gwpBusy = true; setBusy(true);
      cartPost('/cart/add.js', { id: Number(newId), quantity: 1 })
        .then(getCart)
        .then(function(cart){
          var body = q('[data-cd-body]');
          var handles = (body.getAttribute('data-gwp-handles') || '').split(',');
          var u = {};
          cart.items.filter(function(it){ return handles.indexOf(it.handle) !== -1; }).forEach(function(it){ if (String(it.id) !== String(newId)) u[it.key] = 0; });
          return cartPost('/cart/update.js', Object.keys(u).length ? { updates: u } : {});
        })
        .then(function(nc){ gwpBusy = false; apply(nc); setBusy(false); });
      return;
    }
  }, true);

  document.addEventListener('change', function(e){
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-cd-note')) {
      cartPost('/cart/update.js', { note: e.target.value });
    }
  });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-cd-checkout-form')) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openDrawer();
    var rendered = form.closest('.lits-cd') ? false : optimisticAdd(form);
    if (rendered) markSyncing(true); else setBusy(true);
    addForm(new FormData(form)).then(function(res){ apply(res); setBusy(false); markSyncing(false); return maybeAutoGwp(); }).catch(function(){ setBusy(false); markSyncing(false); });
  }, true);

  var _fetch = window.fetch;
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add') !== -1;
    var isMine = init && init.headers && init.headers['X-LITS-Drawer'];
    var p = _fetch.apply(this, arguments);
    if (isAdd && !isMine) { p.then(function(res){ if (res && res.ok) { openDrawer(); setBusy(true); refresh(); } }).catch(function(){}); }
    return p;
  };

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeDrawer(); });
})();